module.exports = __webpack_public_path__ + "static/media/ace-card.9579b978.svg";